(() => {
  function init(root = document) {
    root.querySelectorAll('[data-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const grid = catalog.querySelector('[data-grid]');
      const cards = [...grid.querySelectorAll('.product-card')];
      const categories = catalog.querySelector('[data-categories]');
      const search = catalog.querySelector('[data-search-input]');
      const sort = catalog.querySelector('[data-sort]');
      const names = ['Alla', ...new Set(cards.map(card => card.dataset.category).filter(Boolean))];
      let selected = new URLSearchParams(location.search).get('kategori') || 'Alla';
      if (!names.includes(selected)) selected = 'Alla';
      function update() {
        const query = search.value.trim().toLocaleLowerCase('sv');
        const ordered = [...cards];
        if (sort.value === 'az') ordered.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title, 'sv'));
        if (sort.value === 'price') ordered.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
        let count = 0;
        ordered.forEach(card => {
          card.hidden = !((selected === 'Alla' || card.dataset.category === selected) && card.dataset.search.toLocaleLowerCase('sv').includes(query));
          if (!card.hidden) count++;
          grid.appendChild(card);
        });
        catalog.querySelector('[data-count]').textContent = `${count} motiv`;
        catalog.querySelector('[data-empty]').hidden = count !== 0 || cards.length === 0;
        categories.querySelectorAll('button').forEach(button => {
          const active = button.textContent === selected;
          button.classList.toggle('active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }
      names.forEach(name => { const button = document.createElement('button'); button.type = 'button'; button.textContent = name; button.addEventListener('click', () => { selected = name; update(); }); categories.appendChild(button); });
      categories.hidden = false;
      catalog.querySelector('[data-controls]').hidden = false;
      search.addEventListener('input', update);
      sort.addEventListener('change', update);
      update();
    });
    root.querySelectorAll('.purchase-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('change', event => { if (event.target.matches('input[name=id]')) form.closest('.detail-copy').querySelector('[data-product-price]').textContent = event.target.dataset.priceLabel; });
      const file = form.querySelector('[data-custom-file]');
      if (!file) return;
      const text = form.querySelector('[data-custom-text]');
      const error = form.querySelector('[data-form-error]');
      form.addEventListener('submit', event => {
        const chosen = file.files[0];
        let message = '';
        if (!text.value.trim() && !chosen) message = 'Skriv en text eller välj en bild till din plansch.';
        if (chosen && chosen.size > 10 * 1024 * 1024) message = 'Bilden får vara högst 10 MB. Välj en mindre fil eller mejla oss.';
        if (chosen && !['image/jpeg','image/png','image/webp'].includes(chosen.type)) message = 'Välj en JPG-, PNG- eller WebP-bild.';
        error.textContent = message; error.hidden = !message;
        if (message) { event.preventDefault(); (chosen ? file : text).focus(); }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
